// Package imports:
import React, { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
// Style imports:
// import './AlertsAll.scss';
// Component imports:
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import AlertStats from './AlertStats';
import HomeAlerts from './HomeAlerts';
import DatePickerRange from '../common/DatePickerRange';
// Service imports:
import { _for } from '../../services/utils';
// Action imports:
import { requestAlerts } from '../../redux-store/actions/alertActions';
// Type imports:
import { RootState } from '../../redux-store/reducers';

type ReduxProps = ConnectedProps<typeof connector>
type Props = ReduxProps;

/**
 *  This is the main component for the Alerts page. **Alerts From Navigation Bar**
 **/
const AlertsAll: React.FC<Props>  = ({
    alertsByDate,
    dayRange,
    accessTokenV2,
    requestAlerts
}) => {
    useEffect(() => {
        document.title = 'Alerts | KODIAK Sigti';
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            if (dayRange !== undefined) {
                const { fromDate, toDate } = dayRange;
                let hasEmptyFields = false;
                _for(fromDate, toDate, (currentDate) => {
                    const alertInfo = alertsByDate[currentDate];
                    if (alertInfo === undefined) {
                        hasEmptyFields = true;
                        return 'break';
                    }
                });
                if (hasEmptyFields && accessTokenV2) {
                    requestAlerts(accessTokenV2, fromDate, toDate);
                }
            }
        }
        fetchData();
    }, [ alertsByDate, dayRange, accessTokenV2, requestAlerts ]);


    return (
        <Container fluid id='AlertsAll'>
            {/* ================== Secondary Nav Bar ================== */}
            <Row className='SecondaryNavBar'>
                <Col
                    className='DatePickerRangeCol'
                    xl={6} md={12} xs={12}
                >
                    <DatePickerRange />
                </Col>
                <Col
                    className='AlertStatsWrapper' 
                    xl={6} md={12} xs={12}
                >
                    <AlertStats
                        alertsByDate={alertsByDate}
                        dayRange={dayRange}
                        currentTradingDay={undefined}
                    />
                </Col>
            </Row>
            {/* ================== List of all Alerst ================== */}
            <HomeAlerts
                allowStatusFilter={true}
                allowFiltering={true}
                dayRange={dayRange}
                currentTradingDay={undefined}
                showDateInTimestamp={true}
                hideScrollbarInTable={false}
            />
        </Container>
    );
}

function mapStateToProps({ dashboardReducer, alertReducer, loginReducer }: RootState) {
    const { dayRange } = dashboardReducer;
    const { accessTokenV2 } = loginReducer;
    const { alertsByDate } = alertReducer;
    return {
        dayRange,
        accessTokenV2,
        alertsByDate
    };
}

const connector = connect(mapStateToProps, { requestAlerts });
export default connector(AlertsAll);
